import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/report`;
const endpoints = {
    getCropAndCropVarietyReport: () => `${RESOURCE_ENDPOINT}/crop-variety`,

    getFinancialYearWiseRiceSeedbedPlanningReport: () => `${RESOURCE_ENDPOINT}/financial-year-wise-rice-seedbed-planning`,
    getVarietyWiseRiceSeedbedPlanningReport: () => `${RESOURCE_ENDPOINT}/variety-wise-rice-seedbed-planning`,
    getLocationWiseRiceSeedbedPlanningReport: () => `${RESOURCE_ENDPOINT}/location-wise-rice-seedbed-planning`,

    getFinancialYearWiseCropProductionPlanningReport: () => `${RESOURCE_ENDPOINT}/financial-year-wise-crop-production-planning`,
    getFinancialYearHqCropProductionPlanningReport: () => `${RESOURCE_ENDPOINT}/financial-year-wise-hq-crop-production-planning`,
    getLocationWiseCropProductionPlanningReport: () => `${RESOURCE_ENDPOINT}/location-wise-crop-production-planning`,

    getVarietyWiseDailyProductionReport: () => `${RESOURCE_ENDPOINT}/variety-wise-daily-production`,
    getLocationWiseDailyProductionReport: () => `${RESOURCE_ENDPOINT}/location-wise-daily-production`,
    getLocationWiseHqDailyProductionReport: () => `${RESOURCE_ENDPOINT}/location-wise-hq-daily-production`,
    getvarietyTypewiseDailyProductionReport: () => `${RESOURCE_ENDPOINT}/variety-type-wise-daily-production`,
    getvarietywiseCropDailyCultavationProgressReport: () => `${RESOURCE_ENDPOINT}/variety-wise-daily-cultivation-progress`,
    getVarietywiseHQDailyProductionReport: () => `${RESOURCE_ENDPOINT}/variety-wise-hq-daily-production`,

    getDateWiseCropStagingReport: () => `${RESOURCE_ENDPOINT}/date-wise-crop-staging`,
    getLocationWiseCropStagingReport: () => `${RESOURCE_ENDPOINT}/location-wise-crop-staging`,
 getLocationwiseCropStagingPercentage: () => `${RESOURCE_ENDPOINT}/location-wise-crop-staging-percentage`,
    getFinancialYearWiseRiceSeedbedProductionReport: () => `${RESOURCE_ENDPOINT}/financial-year-wise-seedbed-production`,
    getVarietyWiseRiceSeedbedProductionReport: () => `${RESOURCE_ENDPOINT}/variety-wise-rice-seedbed-production`,
    getLocationWiseRiceSeedbedProductionReport: () => `${RESOURCE_ENDPOINT}/location-wise-seedbed-production`,

    getFiscalYearWiseCropTargetAndAchievedLandAndProductionAndYieldReport: () => `${RESOURCE_ENDPOINT}/get-fiscal-year-wise-crop-target-and-achieved-land-and-production-and-yield`,

    // Fertilizer Report Endpoint Start
    getFertilizerDemandList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-demand-list`,
    getFertilizerCollectionList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-collection-list`,
    getFertilizerAllocationList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-allocation-list`,
    getFertilizerExpenditureList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-expenditure-list`,
    getDealerWiseFertilizerCollectionProcessList: () => `${RESOURCE_ENDPOINT}/dealer-wise-fertilizer-collection-process`,
    getFertilizerCaseList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-case-list`,
    getFertilizerDistributionCollectionList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-distribution-collection-list`,
    FertilizerPurchaseSale: () => `${RESOURCE_ENDPOINT}/get-fertilizer-purchase-sale`,
    getFertilizerStockList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-stock-list`,
    getFertilizerStockSummary: () => `${RESOURCE_ENDPOINT}/get-fertilizer-stock-summary`,
    getFertilizerDealerList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-dealer-list`,
    getFertilizerDistributionList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-distribution-list`,
    getFertilizerSampleTestingReportList: () => `${RESOURCE_ENDPOINT}/get-fertilizer-sample-testing-list`,
    // Fertilizer Report Endpoint End

    // seed start
    getCropSeedDemandReport: () => `${RESOURCE_ENDPOINT}/crop-seed-demand`,
    getCropSeedPreservationReport: () => `${RESOURCE_ENDPOINT}/crop-seed-preservation`,

    // seed end

    // Daily Summary Report Start
    getRiceSeedbedProductionProgressReportList: () => `${RESOURCE_ENDPOINT}/rice-seedbed-production-progress`,
    getRiceStagingPercentageReportList: () => `${RESOURCE_ENDPOINT}/rice-staging-percentage`,
    getCropTargetProductionReportList: () => `${RESOURCE_ENDPOINT}/crop-target-production`,

    // Daily Summary Report End

    // Monitoring Report Start
    getPreliminaryReportList: () => `${RESOURCE_ENDPOINT}/monitoring-report/preliminary-report`,
    // Monitoring Report End

    // PARTNER PROGRAM Endpoint Start
    getPFSDLIoneMISList: () => `${RESOURCE_ENDPOINT}/pfs-mis`,
    getAgricultureDemonstrationList: () => `${RESOURCE_ENDPOINT}/agriculture-demonstration-dlr-five`,
    getTrainingList: () => `${RESOURCE_ENDPOINT}/training`,
    getTrainingSummaryList: () => `${RESOURCE_ENDPOINT}/training-summary`,
    getLocationwiseTrainingSummaryList: () => `${RESOURCE_ENDPOINT}/locationwise-training-summary`,
    getLocationwiseDisasterReport: () => `${RESOURCE_ENDPOINT}/location-wise-disaster`,
    getRiceSeedProductionDLRTwoTwoReport: () => `${RESOURCE_ENDPOINT}/rice-seed-production-dlr-two-two`,
    getNewRiceVarietyDLRTwoThreeReport: () => `${RESOURCE_ENDPOINT}/new-rice-variety-two-three`,
    getNonRiceSeedProductionDLRThreeTwoReport: () => `${RESOURCE_ENDPOINT}/non-rice-seed-production-dlr-three-two`,
    getNonRiceVarietyDLRThreeThreeReport: () => `${RESOURCE_ENDPOINT}/non-rice-variety-dlr-three-three`,
    getIrrigationDLRFourTwoReport: () => `${RESOURCE_ENDPOINT}/irrigation-dlr-four-two`,

    // PARTNER PROGRAM Endpoint End

    //Pesticide Endpoint Start
    getFarmerDigitalPrescriptionList: () => `${RESOURCE_ENDPOINT}/farmer-digital-prescription`,
    //Pesticide Endpoint End

    //Irrigation Endpoint Start
    getIrrigationEquipmentList: () => `${RESOURCE_ENDPOINT}/irrigation-equipment-list`,
    //Irrigation Endpoint End

    //Incentive Allocation Distribution Summery
     getAllocationDistributionSummeryReportList: () => `${RESOURCE_ENDPOINT}/get-allocation-distribution-summery-report`,
    //Incentive Distribution
     getIncentiveBeneficiaryReportList: () => `${RESOURCE_ENDPOINT}/get-incentive-beneficiary-report`,

    //Planted Seedling
    getIncentiveDistributionReportList: () => `${RESOURCE_ENDPOINT}/get-incentive-distribution-report`,

    //Tree Plantation Distribution
    getTreePlantationDistributionReportList: () => `${RESOURCE_ENDPOINT}/get-tree-plantation-distribution-report`,

    // Procurement Endpoint Start
    getAnnualProcurementPerformanceList: () => `${RESOURCE_ENDPOINT}/annual-procurement-performance`,
    getProcurementPurchaseInformationList: () => `${RESOURCE_ENDPOINT}/procurement-purchase-information`,
    getLocationwiseUserReportList: () => `${RESOURCE_ENDPOINT}/location-wise-user-report`,

    // Procurement Endpoint End
    // Weather Endpoint Start
    getDailyRainfall: () => `${RESOURCE_ENDPOINT}/daily-rainfall`,
    // Weather Endpoint end
};

export default class QisReportApi {
    public getCropAndCropVarietyReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCropAndCropVarietyReport();
        return HttpService.get(url, params, headers);
    };
    public getFinancialYearWiseRiceSeedbedPlanningReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFinancialYearWiseRiceSeedbedPlanningReport();
        return HttpService.get(url, params, headers);
    };
    public getVarietyWiseRiceSeedbedPlanningReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getVarietyWiseRiceSeedbedPlanningReport();
        return HttpService.get(url, params, headers);
    };
    public getLocationWiseRiceSeedbedPlanningReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationWiseRiceSeedbedPlanningReport();
        return HttpService.get(url, params, headers);
    };
    public getFinancialYearWiseCropProductionPlanningReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFinancialYearWiseCropProductionPlanningReport();
        return HttpService.get(url, params, headers);
    };
    public getFinancialYearHqCropProductionPlanningReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFinancialYearHqCropProductionPlanningReport();
        return HttpService.get(url, params, headers);
    };
    public getLocationWiseCropProductionPlanningReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationWiseCropProductionPlanningReport();
        return HttpService.get(url, params, headers);
    };

    public getVarietyWiseDailyProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getVarietyWiseDailyProductionReport();
        return HttpService.get(url, params, headers);
    };
    public getLocationWiseDailyProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationWiseDailyProductionReport();
        return HttpService.get(url, params, headers);
    };
    public getLocationWiseHqDailyProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationWiseHqDailyProductionReport();
        return HttpService.get(url, params, headers);
    };

    public getvarietyTypewiseDailyProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getvarietyTypewiseDailyProductionReport();
        return HttpService.get(url, params, headers);
    };

    public getvarietywiseCropDailyCultavationProgressReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getvarietywiseCropDailyCultavationProgressReport();
        return HttpService.get(url, params, headers);
    };

    public getVarietywiseHQDailyProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getVarietywiseHQDailyProductionReport();
        return HttpService.get(url, params, headers);
    };

    public getDateWiseCropStagingReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDateWiseCropStagingReport();
        return HttpService.get(url, params, headers);
    };

    public getLocationWiseCropStagingReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationWiseCropStagingReport();
        return HttpService.get(url, params, headers);
    };

        public getLocationWiseCropStagingPercentageReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationwiseCropStagingPercentage();
        return HttpService.get(url, params, headers);
    };

    public getFinancialYearWiseRiceSeedbedProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFinancialYearWiseRiceSeedbedProductionReport();
        return HttpService.get(url, params, headers);
    };
    public getVarietyWiseRiceSeedbedProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getVarietyWiseRiceSeedbedProductionReport();
        return HttpService.get(url, params, headers);
    };
    public getLocationWiseRiceSeedbedProductionReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationWiseRiceSeedbedProductionReport();
        return HttpService.get(url, params, headers);
    };
    public getFiscalYearWiseCropTargetAndAchievedLandAndProductionAndYieldReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFiscalYearWiseCropTargetAndAchievedLandAndProductionAndYieldReport();
        return HttpService.get(url, params, headers);
    };

    // Fertilizer Report Endpoint Start
    public getFertilizerDemandList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerDemandList();
        return HttpService.get(url, params, headers);
    };
    public getFertilizerCollectionList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerCollectionList();
        return HttpService.get(url, params, headers);
    };

    public getFertilizerAllocationList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerAllocationList();
        return HttpService.get(url, params, headers);
    };
    public getDealerWiseFertilizerCollectionProcessList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDealerWiseFertilizerCollectionProcessList();
        return HttpService.get(url, params, headers);
    };

    public getFertilizerExpenditureList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerExpenditureList();
        return HttpService.get(url, params, headers);
    };

    public getFertilizerCaseList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerCaseList();
        return HttpService.get(url, params, headers);
    };
    public getFertilizerDistributionCollectionList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerDistributionCollectionList();
        return HttpService.get(url, params, headers);
    };
    public getFertilizerStockList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerStockList();
        return HttpService.get(url, params, headers);
    };




      public FertilizerPurchaseSale = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.FertilizerPurchaseSale();
        return HttpService.get(url, params, headers);
    };

    public getFertilizerStockSummary = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerStockSummary();
        return HttpService.get(url, params, headers);
    };

    public getFertilizerDealerList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerDealerList();
        return HttpService.post(url, payload, params, headers);
    };

    public getFertilizerDistributionList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerDistributionList();
        return HttpService.post(url, payload, params, headers);
    };

    public getFertilizerSampleTestingReportList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerSampleTestingReportList();
        return HttpService.post(url, payload, params, headers);
    };
    // Fertilizer Report Endpoint End

    // Seed start

    public getCropSeedDemandReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCropSeedDemandReport();
        return HttpService.get(url, params, headers);
    };
    public getCropSeedPreservationReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCropSeedPreservationReport();
        return HttpService.get(url, params, headers);
    };

    // Seed End

    // Daily Summary Reports start
    public getRiceSeedbedProductionProgressReportList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getRiceSeedbedProductionProgressReportList();
        return HttpService.get(url, params, headers);
    };
    public getRiceStagingPercentageReportList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getRiceStagingPercentageReportList();
        return HttpService.get(url, params, headers);
    };
    public getCropTargetProductionReportList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCropTargetProductionReportList();
        return HttpService.get(url, params, headers);
    };
    // Daily Summary Reports end

    // Monitoring Report start
    public getPreliminaryReportList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPreliminaryReportList();
        return HttpService.get(url, params, headers);
    };
    // Monitoring Report end

    // PARTNER PROGRAM Endpoint Start
    public getPFSDLIoneMISList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPFSDLIoneMISList();
        return HttpService.post(url, payload, params, headers);
    };

    public getAgricultureDemonstrationList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAgricultureDemonstrationList();
        return HttpService.post(url, payload, params, headers);
    };

    public getTrainingList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTrainingList();
        return HttpService.post(url, payload, params, headers);
    };

    public getTrainingSummaryList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.getTrainingSummaryList();
    return HttpService.post(url, payload, params, headers);
    };

    public getLocationwiseTrainingSummaryList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationwiseTrainingSummaryList();
        return HttpService.post(url, payload, params, headers);
    };

    public getLocationwiseDisasterReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationwiseDisasterReport();
        return HttpService.post(url, payload, params, headers);
    };

    public getRiceSeedProductionDLRTwoTwoReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getRiceSeedProductionDLRTwoTwoReport();
        return HttpService.get(url, params, headers);
    };

    public getNewRiceVarietyDLRTwoThreeReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNewRiceVarietyDLRTwoThreeReport();
        return HttpService.get(url, params, headers);
    };

    public getNonRiceSeedProductionDLRThreeTwoReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNonRiceSeedProductionDLRThreeTwoReport();
        return HttpService.get(url, params, headers);
    };

    public getNonRiceVarietyDLRThreeThreeReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNonRiceVarietyDLRThreeThreeReport();
        return HttpService.get(url, params, headers);
    };

    public getIrrigationDLRFourTwoReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIrrigationDLRFourTwoReport();
        return HttpService.get(url, params, headers);
    };

    // PARTNER PROGRAM Endpoint end

    //Pesticide Endpoint Start
    public getFarmerDigitalPrescriptionList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFarmerDigitalPrescriptionList();
        return HttpService.post(url, payload, params, headers);
    };

    //Pesticide Endpoint end

    //Irrigation Endpoint Start
    public getIrrigationEquipmentList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIrrigationEquipmentList();
        return HttpService.post(url, payload, params, headers);
    };

    //Irrigation Endpoint end

    //Incentive Distribution
    public getAllocationDistributionSummeryReportList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAllocationDistributionSummeryReportList();
        return HttpService.post(url, payload, params, headers);
    };

    //Incentive Distribution
     public getIncentiveBeneficiaryReportList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIncentiveBeneficiaryReportList();
        return HttpService.post(url, payload, params, headers);
    };

    //Planted Seedling
    public getIncentiveDistributionReportList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIncentiveDistributionReportList();
        return HttpService.post(url, payload, params, headers);
    };

    //Tree Plantation Distribution
    public getTreePlantationDistributionReportList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTreePlantationDistributionReportList();
        return HttpService.post(url, payload, params, headers);
    };

    //Procurement Endpoint Start
    public getAnnualProcurementPerformanceList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAnnualProcurementPerformanceList();
        return HttpService.post(url, payload, params, headers);
    };

    public getProcurementPurchaseInformationList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getProcurementPurchaseInformationList();
        return HttpService.post(url, payload, params, headers);
    };

    //Procurement Endpoint end

    // Weather Endpoint Start
    public getDailyRainfall = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDailyRainfall();
        return HttpService.post(url, payload, params, headers);
    };

//User
        public getLocationwiseUserReportList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationwiseUserReportList();
        return HttpService.post(url, payload, params, headers);
    };
    // Weather Endpoint end
}
